import React from "react";
import SelectRS from "react-select";

export const Select = props => {
  const { ...restProps } = props;

  return <SelectRS className="ah-select" {...restProps} />;
};
